export default "__VITE_ASSET__9e97b3ba__"